import {Divider, withStyles} from "@material-ui/core";
import BoldTypography from "components/BoldTypography";
import GridBlock from "components/GridBlock";
import React, {useRef, useState} from "react";
import Tr from "translations/Translations";
import ApprovalHistory from "./ApprovalHistory";
import * as PropTypes from "prop-types";
import Dialog from "components/Dialog";
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import Form from "components/Form";
import reduxStore from "redux/store";
import AddApproversTable from "./AddApproversTable";
import * as Yup from "yup";
import VS from "constants/ValidationShema";


const style = (theme) => ({
    title: {
        marginTop: theme.spacing(4),
        marginLeft: theme.spacing(2)
    },
    fullWidth: {
        width: '100%'
    }
})

function ApprovalHistoryList(
    {
        approvalObjectName,
        approvalHistoryList,
        loadApprovalHistory,
        getAvailableApprovers,
        addApprovers,
        deleteApprover,
        classes
    }) {

    const approvalAndStage = useRef([]);
    const [availableApprovers, setAvailableApprovers] = useState(null);
    const [working, setWorking] = useState(false);

    const getButtons = () => {
        const buttons = [];
        buttons.push(createButton(Tr("cancel"), () => {
            approvalAndStage.current = null;
            setAvailableApprovers(null);
        }, "outlined"));
        buttons.push(createButton(Tr('approval_history_addApprover'), () => {
            const {form} = reduxStore.getState();
            form['ApprovalHistoryAddApproval']();
        }, undefined, !availableApprovers.length || working));
        return buttons;
    }

    const validationSchema = Yup.object().shape({
        approvers: VS.any().test("approverSelected", Tr("approval_history_addApprover_atLeastOne"), (e) => {
            const selIndex = Object.keys(e).findIndex(x => e[x] === true);
            return selIndex > -1;
        })
    })

    const showApproverPopup = async (approval, stage) => {
        const resp = await getAvailableApprovers(approval, stage);
        if (!!resp) {
            approvalAndStage.current = [approval.identity, stage.identity];
            setAvailableApprovers(resp)
        }
    }

    const doAddApprovers = (values) => {
        setWorking(true);
        addApprovers(approvalAndStage.current[0], approvalAndStage.current[1], Object.keys(values.approvers).filter(a => values.approvers[a] === true).map(a => Number(a))).then(resp => {
            if (resp) {
                approvalAndStage.current = null;
                setAvailableApprovers(null);
            } else {
                setWorking(false);
            }
        });
    }

    return (
        <>
            <BoldTypography className={classes.title}>{Tr('approval_history')}</BoldTypography>
            <GridBlock
                direction='column'
                alignItems='center'
                itemClassName={classes.fullWidth}
            >
                {approvalHistoryList.map((approvalHistoryHeader, index) => (
                    <div key={`ah${approvalHistoryHeader.approvalId}`}>
                        <ApprovalHistory approvalObjectName={approvalObjectName} approvalHistoryHeader={approvalHistoryHeader}
                                         loadApprovalHistory={loadApprovalHistory}
                                         showApproverPopup={showApproverPopup} deleteApprover={deleteApprover}/>
                        <Divider className={classes.divider}/>
                    </div>
                ))
                }
            </GridBlock>
            {!!availableApprovers && <Dialog
                open
                title={Tr('approval_history_addApprover_popup')}
                dialogActions={<>
                    <GridBlock column>
                        <MultiButton buttons={getButtons()}/>
                    </GridBlock>
                </>}
                maxWidth="md"
            >
                <GridBlock
                    column
                >
                    <Form
                        initialValues={{
                            approvers: availableApprovers.reduce((prev, cur) => {
                                prev[cur.identity] = false;
                                return prev;
                            }, {}),
                            search: '',
                            hidden: []
                        }}
                        validationSchema={validationSchema}
                        onSubmit={doAddApprovers}
                        id={'ApprovalHistoryAddApproval'}
                    >
                        {(formikProps) => (
                            <GridBlock
                                column
                            >
                                <AddApproversTable
                                    label={Tr('approval_history_addApprover_popup')}
                                    id="approvers"
                                    formikProps={formikProps}
                                    elementList={availableApprovers}
                                />
                                {
                                    !(availableApprovers.length) &&
                                    <BoldTypography variant="body1">
                                        {
                                            Tr("no_options")
                                        }
                                    </BoldTypography>
                                }
                            </GridBlock>
                        )}
                    </Form>

                </GridBlock>
            </Dialog>
            }
        </>);
}

ApprovalHistoryList.propTypes = {
    approvalObjectName: PropTypes.string,
    approvalHistoryList: PropTypes.array,
    loadApprovalHistory: PropTypes.func,
    classes: PropTypes.any
}

export default withStyles(style)(ApprovalHistoryList);